import React from 'react';
import { Breadcrumb, Col, Row, Tab, Tabs } from 'react-bootstrap';
import ChangePassword from './component/ChangePassword/component/ChangePassword';
import Profile from './component/Profile/component/Profile';

const PersonalInformation = () => {
  return (
    <Row>
      <Col md="12" className="d-flex align-items-center">
        <div className="mainTitle">
          <Breadcrumb>
            <Breadcrumb.Item>Personal Information</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </Col>
      <Col className="settings-warpper">
        <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-1">
          <Tab eventKey="profile" title="Profile">
            <Profile />
          </Tab>
          <Tab eventKey="Password" title="Password">
            <ChangePassword />
          </Tab>
        </Tabs>
      </Col>
    </Row>
  );
};

export default PersonalInformation;
